import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

interface IMetadataSlice {
  availableQueries: IAvailableQueries;
}
interface IAvailableQueries {
  years:string[], 
  models:string[], 
  modelIds:string[]
  modelsByYear: {[key:string]: string[]}
}

let initialState: IMetadataSlice = {
  availableQueries:{
    years: [],
    models: [],
    modelIds: [],
    modelsByYear: {}
  }
}
export const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setBapAvailableQueries: (state, action: PayloadAction<IAvailableQueries>) => {
      const newValues = {
        years: action.payload.years,
        models: action.payload.models,
        modelIds: action.payload.modelIds,
        modelsByYear: action.payload.modelsByYear
      }
      state.availableQueries = newValues;
    },
  },
});

export const { setBapAvailableQueries } = metadataSlice.actions;

export const getBapAvailableQueries = (state: RootState) => state.metadata.availableQueries;

export default metadataSlice.reducer;
